/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button, colors, Hidden, Divider, Collapse } from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStore } from 'context/store';
import { logOutUser } from 'context/actions';

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  collapse: {
    justifyContent: "space-between"
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  }
}));


const CustomRouterLink = forwardRef((props, ref) => {
  return <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
});

const SidebarNav = props => {
  const { pages, className, ...rest } = props;
  const dispatch = useStore()[1];
  const classes = useStyles();
  const regex = new RegExp(window.location.pathname, "g");
  const current = pages.findIndex(page => page.collapse ? page.collapse.find(el => regex.test(el.href)) : false)
  const [expanded, setExpanded] = React.useState(current)
  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      {pages.map((page, i) => (
        page.collapse ?
          <React.Fragment key={i}>
            <ListItem
              className={classes.item}
              disableGutters
            >
              <div style={{ flexGrow: 1 }}>
                <Button
                  className={`${classes.button} ${classes.collapse}`}
                  onClick={() => setExpanded(expanded === i ? false : i)}
                >
                  <div style={{ display: "flex" }}>
                    <div className={classes.icon}>{page.icon}</div>
                    {page.title}
                  </div>
                  {expanded === i ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Button>
              </div>
            </ListItem>
            <Collapse in={expanded === i} timeout="auto" unmountOnExit>
              {page.collapse.map((el, i) =>
                <ListItem
                  className={classes.item}
                  key={i}
                >
                  <Button
                    activeClassName={classes.active}
                    className={classes.button}
                    component={CustomRouterLink}
                    exact={el.exact}
                    to={el.href}
                  >
                    <div className={classes.icon}>{el.icon}</div>
                    {el.title}
                  </Button>
                </ListItem>
              )}
            </Collapse>
          </React.Fragment>
          :
          <ListItem
            className={classes.item}
            disableGutters
            key={page.title}
          >
            <Button
              activeClassName={classes.active}
              className={classes.button}
              component={CustomRouterLink}
              exact={page.exact}
              onClick={() => setExpanded(false)}
              to={page.href}
            >
              <div className={classes.icon}>{page.icon}</div>
              {page.title}
            </Button>
          </ListItem>
      ))}
      <Hidden lgUp>
        <Divider />
        <ListItem
          className={classes.item}
          disableGutters
        >
          <Button
            className={classes.button}
            onClick={() => dispatch(logOutUser())}
          >
            <div className={classes.icon}><InputIcon /></div>
            خروج
          </Button>
        </ListItem>
      </Hidden>
    </List >
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
